import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ar from './locales/ar.json';
import he from './locales/he.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  he: { translation: he },
};

// Supported languages: prefer full locale but fallback to base (e.g. en-US -> en)
const supportedLngs = ['en', 'ar', 'he'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'stylon_company_lang',
    },
  });

// Keep document lang/dir in sync so the browser doesn't auto-translate when language changes
i18n.on('languageChanged', (lng) => {
  const lang = (lng || '').split('-')[0] || 'en';
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.setAttribute('lang', supportedLngs.includes(lang) ? lang : 'en');
    document.documentElement.setAttribute('dir', ['ar', 'he'].includes(lang) ? 'rtl' : 'ltr');
  }
});

export default i18n;
